import {
  CampaignContributionQuery,
  PerformantCampaignQuery,
  QueryData,
  CampaignContributionCSVExportQuery,
} from 'modules/iterableGoals/types';

import { postRaw } from 'services/api';
import client from './ApolloClient';
import {
  fetchCampaignContributionsQuery,
  fetchPerformantCampaignsQuery,
} from './queries/iterableGoals';

export const GOAL_AGGREGATE_METRICS_URL = '/analytics/metrics/aggregate';
export const GOAL_STATS_FOR_TIME_RANGE_URL = '/analytics/getStatsForTimeRange';
export const GOAL_ANALYTICS_METRICS = '/analytics/metrics/goal';
export const CAMPAIGN_CONTRIBUTION_CSV_EXPORT = '/analytics/goal/campaign/export';

export const fetchGoalMetrics = (queryData: QueryData) => {
  return postRaw(GOAL_AGGREGATE_METRICS_URL, queryData);
};

export const fetchStatsForTimeRange = (queryData: any) =>
  postRaw(GOAL_STATS_FOR_TIME_RANGE_URL, queryData);

export const fetchGoalAnalytics = (queryData: any) => postRaw(GOAL_ANALYTICS_METRICS, queryData);

export const fetchPerformantCampaigns = (variables: PerformantCampaignQuery) =>
  client.query({ query: fetchPerformantCampaignsQuery, variables });

export const fetchCampaignContributions = (variables: CampaignContributionQuery) =>
  client.query({ query: fetchCampaignContributionsQuery, variables });

export const fetchCampaignContributionCSVExport = (queryData: CampaignContributionCSVExportQuery) =>
  postRaw(CAMPAIGN_CONTRIBUTION_CSV_EXPORT, queryData);
